<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template #activator="{ on }">
      <v-btn v-on="on" v-if="project.archived" color="primary" dark outlined rounded>
        <v-icon left>mdi-power-sleep</v-icon>
        Archived
      </v-btn>
      <v-btn v-else color="primary" v-on="on" dark outlined rounded>
        <v-icon left>mdi-run</v-icon>
        Active
      </v-btn>
    </template>
    <v-card>
      <v-card-title v-if="project.archived">
        Activate Project
        <v-spacer/>
        <v-btn icon><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-title v-else>
        Archive Project
        <v-spacer/>
        <v-btn icon><v-icon>exit</v-icon></v-btn>
      </v-card-title>
      <v-card-subtitle v-if="project.archived">
        Activating a project will bring it back into the default Project List View. Note that
        this will not un-archive all batches.
      </v-card-subtitle>
      <v-card-subtitle v-else>
        Archiving a project will remove it from the default Project List indicating that it's completed.
        All batches in this project will also archive which removes them from processing, shipping, or QC options.
        You can always un-archive if you need resume or restart a project.
      </v-card-subtitle>
      <v-card-text v-if="project.archived" class="body-1 primary--text font-weight-medium">
        Activate {{ project.forgeID }} - {{ project.name }}
      </v-card-text>
      <v-card-text v-else class="body-1 primary--text font-weight-medium">
        Archive {{ project.forgeID }} - {{ project.name }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn text @click="changeState" :loading="loading" color="green">
          <v-icon left>save</v-icon>
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Project from "../../models/Project";
export default {
  name: "ProjectArchiveButton",
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialog: false
    }
  },
  methods: {
    changeState() {
      this.loading = true;
      Project
        .$put(this.project.id, { archived: !this.project.archived })
        .then(() => {
          this.dialog = false;
          this.loading = false;
        })
    }
  }
}
</script>
